import Styled from "styled-components";

export const Quantity = Styled.div`
 button {
  color: ${props => props.theme.whitelabel?.theme?.text_primary_color} !important;
  padding-left: 0;
  padding-right: 0;
  min-width: auto;
  svg {
    color: ${props => props.theme.whitelabel?.theme?.text_primary_color} !important;
  }
 }

 .quantity-display {
  color: ${props => props.theme.whitelabel?.theme?.text_primary_color} !important;
  font-size: 14px;
  font-weight: 600;
  margin: 0 24px;
 }
`;

export const ProductValue = Styled.span`
  color: ${props => props.theme.whitelabel?.theme?.text_primary_color} !important;
  font-size: 12px;
  font-weight: 700;
`;